import Alert from '@cobliteam/ui/components/Alert';
import type { ReactElement } from 'react';

/**
 * Helper compartilhado do toast de card: renderiza um nó (o card do tipo) como toast do sonner, top-right,
 * sem moldura do wrapper (só a do card aparece) e sem auto-dismiss. O `id` é fixo por tipo → cada novo
 * evento SUBSTITUI o anterior (não empilha), só o último fica visível.
 */
export const showCardToast = (id: string, render: (toastId: string | number) => ReactElement) =>
  Alert.custom(render, {
    id,
    duration: Number.POSITIVE_INFINITY,
    unstyled: true,
    position: 'top-right',
    // Zera a moldura do wrapper do sonner (borda/padding/bg/sombra) — só a do card aparece.
    className: '!border-0 !bg-transparent !p-0 !shadow-none mt-10',
  });

export const dismissToast = (toastId: string | number) => Alert.dismiss(toastId);
